<template>
  <div>
      <footer class="section bg-footer section-main-container">
        <div class="container">
            <div class="row">
                <div class="col-lg-3">
                    <div class="">
                        <h6 class="footer-heading text-uppercase text-white">Get our app</h6>

                        <div class="">
                            <a href=""><img
                                    src="/imgs/gp.png"
                                    class="footer-download-icon img-fluid mt-2"></a>
                            <a href=""> <img
                                    src="/imgs/gp2.png"
                                    class="footer-download-icon img-fluid mt-2"></a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3">
                    <div class="">
                        <h6 class="footer-heading text-uppercase text-white">Quick Links</h6>
                        <ul class="list-unstyled footer-link">
                            <li><a href="/">Home</a></li>
                            <li><a href="/aboutus">About Us</a></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-2">
                    <div class="">
                        <h6 class="footer-heading text-uppercase text-white">Useful Links</h6>
                        <ul class="list-unstyled footer-link">
                            <li><a href="">Career</a></li>
                            <li><a href="/support">Support</a></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="">
                        <h6 class="footer-heading text-uppercase text-white">Contact Us</h6>
                        <table>
                            <tr>
                                <td style="text-align: center; vertical-align: middle;">
                                    <i class="fas fa-envelope contact-info-icon"></i>
                                </td>
                                <td>
                                    <p class="mt-2 contact-info-data"> &nbsp; support@aruvaa.com</p>
                                </td>
                            </tr>
                            <tr>
                                <td style="text-align: center; vertical-align: middle;">
                                    <i class="fas fa-mobile-alt contact-info-icon"></i>
                                </td>
                                <td>
                                    <p class="mt-2 contact-info-data"> &nbsp; +91 92 6363 7477</p>
                                </td>
                            </tr>
                        </table>

 </div>
                </div>

            </div>
        </div>

        <div class="text-center mt-5 container">
            <hr class="footer-hr">
            <div class="d-flex justify-content-center below-hr-container">
                <a href=""><span>Privary Policy</span></a>
                <span class="ml-3 mr-3">|</span>
                <a href=""><span>Terms of use</span></a>
                <span class="ml-3 mr-3">|</span>
                <a href=""><span>Cookie Privacy</span></a>
                <span class="ml-3 mr-3">|</span>
                <a href=""><span>Abuse Policy</span></a>
                <span class="ml-3 mr-3">|</span>
                <a href=""><span>Anti-spam Policy</span></a>
            </div>
            <p class="footer-alt mb-0 f-14 mt-2">2019 © Aruvaa, All Rights Reserved</p>
        </div>
    </footer>
  </div>
</template>

<style scoped>
 .bg-footer {
        background-color: #33383c;
        padding: 50px 0 30px;
    }
    .footer-heading {
        letter-spacing: 2px;
    }
    .footer-link a {
        color: #ffffff;
        font-size: 14px;
        transition: all 0.2s;
        text-decoration: none;
    }
    .footer-link a:hover {
        color: #FDC031;
        text-decoration: none;
    }
    .contact-info {
        color: #ffffff;
        font-size: 14px;
    }
    .footer-alt {
        color: #818282;
        font-size: 12px;
    }
    .footer-heading {
        position: relative;
        padding-bottom: -12px !important;
    }
    .footer-heading:after {
        content: '';
        width: 25px;
        position: absolute;
        left: 0;
        bottom: 0;
        display: block;
    }
    .contact-info-icon {
        color: #ffffff;
        font-size: 16px;
    }
    .contact-info-data {
        color: #ffffff;
        font-size: 16px;
        margin: 0px 0px 0px !important;
    }
    /* Extra small devices (phones, 600px and down) */
    @media  only screen and (max-width: 600px) {
        .footer-download-icon {
            width: 36%;
        }
    }
    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media  only screen and (min-width: 600px) {
        .footer-download-icon {
            width: 36%;
        }
    }
    /* Medium devices (landscape tablets, 768px and up) */
    @media  only screen and (min-width: 768px) {
        .footer-download-icon {
            width: 40%;
        }
    }
    /* Large devices (laptops/desktops, 992px and up) */
    @media  only screen and (min-width: 992px) {
        .footer-download-icon {
            width: 54%;
        }
    }
    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media  only screen and (min-width: 1200px) {
        .footer-download-icon {
            width: 54%;
        }
    }
    .footer-get-trial-button {
        background: #FDC031;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 6px;
        padding-bottom: 6px;
        font-weight: bold;
        border-radius: 4px;
        border: none;
        color: #333;
        text-align: center;
        margin-top: 10px;
        font-weight: 500;
        transition: all 0.5s;
        cursor: pointer;
    }
    .footer-hr {
        border-color: #404447;
        background-color: #404447;
        color: #404447;
    }
    .below-hr-container {
        color: #818282;
        font-size: 12px;
    }
    .below-hr-container a {
        color: #818282;
        font-size: 12px;
    }
    .below-hr-container a:hover {
        text-decoration: none;
    }
    </style>
